const timeoutMinutes = 15;

export const timeoutMs = timeoutMinutes * 60000;

export const jdxActions = {
  SIDE_BY_SIDE: 'SIDE_BY_SIDE',
  JOB_DESCRIPTION: 'JOB_DESCRIPTION',
  ADD_JOB_DESCRIPTION: 'ADD_JOB_DESCRIPTION'
};

export const jdxTitles = {
  SIDE_BY_SIDE: 'Sub-Family Job Descriptions',
  JOB_DESCRIPTION: 'JDX Job Description'
};

// Params is hardcoded until we have a working site
export const getJdxUrlFromAction = (action, session, paramString) => {
  let actionUrl;
  switch (action) {
    case jdxActions.SIDE_BY_SIDE:
      actionUrl = `&Action=SideBySide&Parameter=${paramString}`;
      break;
    case jdxActions.JOB_DESCRIPTION:
      actionUrl = `&Action=JobDescription&Parameter=${paramString}`;
      break;
    case jdxActions.ADD_JOB_DESCRIPTION:
      actionUrl = `&Action=AddJobWorkflow&Parameter=${paramString}`;
      break;
  }
  return `/post.frmWebAuthForm.wgx?SessionKey=${session}${actionUrl}`;
};
